export { SaveAlt as default } from './SaveAlt';
